<section class="site-money-main-wrap" appIntersectionObserver>
    <div class="container">
        <div class="site-money-main">
            <div class="site-common-heading hidden delay-1">
                <h2 class="site-heading-h2">What You Get <span>for Your Money</span></h2>
            </div>
            <div>

            </div>
            <div class="site-money-content hidden delay-2">
                <h4 class="site-heading-h4 m-l">Whether you start your investigation with a Deep Social Media Report at
                    $59.95, add extra features to build a comprehensive due diligence package, or opt for Jury Vetting
                    Reports, Pre-Visa / Immigration Checks, or a Custom Intelligence report, the information is verified
                    by human analysts so you can rely on it to make informed decisions</h4>
                <h4 class="site-heading-h4">Plain or Brand our Reports with your Name & Logo for an extra $20</h4>
                <p class="site-text-p m-l">Subject to your selection, where available, we identify social business media
                    accounts, associated email addresses and mobile numbers, close family and business associates,
                    potential employers or companies they own, criminal and civil cases, bankruptcies, negative
                    information posted in blogs and other online articles, evidence of wrongdoing, location of hidden
                    assets, and more.</p>
            </div>
            <div class="site-money-content-columns">
                <div class="site-money-column hidden delay-3" routerLink="/services-fees">
                    <div class="site-money-content-column-inner">
                        <div class="site-money-column-img">
                            <img src="images/svg/robot.svg" alt="Robot Icon">
                        </div>
                        <p class="site-text-p">Technology-assisted data extraction, thoroughly verified and confirmed by
                            professional analysts.</p>
                    </div>
                </div>
                <div class="site-money-column hidden delay-4" routerLink="/services-fees">
                    <div class="site-money-content-column-inner">
                        <div class="site-money-column-img">
                            <img src="images/svg/ranking-star.svg" alt="Ranking Star Icon">
                        </div>
                        <p class="site-text-p">Advanced capture technology provides high-quality visuals and metadata as
                            evidence, unlike basic screenshots.</p>
                    </div>
                </div>
                <div class="site-money-column hidden delay-5" routerLink="/services-fees">
                    <div class="site-money-content-column-inner">
                        <div class="site-money-column-img">
                            <img src="images/svg/person-chalkboard.svg" alt="Person Chalkboard Icon">
                        </div>
                        <p class="site-text-p">Digital reports, including summaries, search indexes to original
                            documents or data links, timelines, and connection schematics.</p>
                    </div>
                </div>
                <div class="site-money-column hidden delay-6" routerLink="/services-fees">
                    <div class="site-money-content-column-inner">
                        <div class="site-money-column-img">
                            <img src="images/svg/browser.svg" alt="Browser Icon">
                        </div>
                        <p class="site-text-p">Manage your searches, credentials, reports, and invoices — all from a
                            single secure dashboard.</p>
                    </div>
                </div>
            </div>
            <div class="site-money-btn hidden delay-7">
                <div class="site-common-btn" routerLink="/order-deep-report/new">
                    <a class="site-btn">Order Your Report Now!</a>
                </div>
            </div>
        </div>
    </div>
</section>